module.exports = __webpack_public_path__ + "static/media/ftMyerFootball.4bc20dc0.png";